import _ from 'lodash'

export const getComponentsAsAry = (state) => {
  return _.values(state.components)
}
